async function getSystems(facilityId) {
    return this.api({
        url: `/cars/facility/${facilityId}/photometers`,
        method: 'GET'
    })
}

async function getCreate (facilityId) {
    return this.api({
        url: `/cars/facility/${facilityId}/photometers/create`,
        method: 'GET'
    })
}

async function getCompliance (photometerId) {
    return this.api({
        url: `/cars/photometer/${photometerId}/compliance`,
        method: 'GET'
    })
}

async function patchCompliance (photometerId, options) {
    return this.api({
        url: `/cars/photometer/${photometerId}/compliance`,
        method: 'PATCH',
        data: {...options}
    })
}

async function patchDataCompliance (photometerId, compliance) {
    return this.api({
        url: `/cars/photometer/${photometerId}/compliance`,
        method: 'PATCH',
        data: {data: compliance}
    })
}

async function submitDataCompliance (photometerId, compliance) {
    return this.api({
        url: `/cars/photometer/${photometerId}/compliance`,
        method: 'POST',
        data: {data: compliance}
    })
}

async function patchGeneralCompliance (photometerId, compliance) {
    return this.api({
        url: `/cars/photometer/${photometerId}/compliance`,
        method: 'PATCH',
        data: {general: compliance}
    })
}

async function submitGeneralCompliance (photometerId, compliance) {
    return this.api({
        url: `/cars/photometer/${photometerId}/compliance`,
        method: 'POST',
        data: {general: compliance}
    })
}

async function getSystem (photometerId) {
    return this.api({
        url: `/cars/photometer/${photometerId}`,
    })
}

async function getSystemEdit (photometerId) {
    return this.api({
        url: `/cars/photometer/${photometerId}/edit`,
    })
}

async function editSystem (photometerId, options) {
    return this.api({
        url: `/cars/photometer/${photometerId}`,
        method: 'PATCH',
        data: Object.fromEntries(Object.entries(options).filter(([_, v]) => v != null && _ != null))
    })
}

async function createSystem (facilityId, options) {
    return this.api({
        url: `/cars/facility/${facilityId}/photometers`,
        method: 'POST',
        data: Object.fromEntries(Object.entries(options).filter(([_, v]) => v != null && _ != null))
    })
}
 
export default {
     pluginName: 'photometer',
     methods: {
        getSystems, getCreate,
        getCompliance, patchCompliance,
        patchDataCompliance, submitDataCompliance,
        patchGeneralCompliance, submitGeneralCompliance,
        getSystem, getSystemEdit, editSystem, createSystem
     }
 }